import { createFeatureActionNamer } from '../../../../redux/action-name';

const getActionName = createFeatureActionNamer('claim-details');

export const ADD_CLAIM_DETAILS_RECORD = getActionName('ADD_CLAIM_DETAILS_RECORD');
